export default class Producer {
	constructor(id, sendRequest, sendTransport) {
		console.debug('stream producer constructor');
		this._id = id;
    this._sendRequest = sendRequest;
    this._sendTransport = sendTransport;

		this._audioProducer = null;
	}

	async produce(mediaStream) {
		console.debug('stream produce', mediaStream);
		const [audioTrack] = mediaStream.getAudioTracks();

		const data = [];

		if (audioTrack) {
			const response = await this.produceAudio({ track: audioTrack, streamId: this._id });
			data.push(response);
		}

		return data;
	}

	async produceAudio({ track, streamId }) {
    try {
      const params = {
        track,
        appData: {
          streamId
        }
      };
  
      this._audioProducer = await this._sendTransport._transport.produce(params);
  
      this._audioProducer.on('transportclose', () => {
        console.log('audio producer transportclose')
        this.close('transportclose')
      });
  
      this._audioProducer.on('trackended', async () => {
        const allDevices = await window.navigator.mediaDevices.enumerateDevices()
        const devices = allDevices.filter(device => device.kind === 'audioinput')
        console.log('devices', devices);
        if (devices && devices.length > 0) {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true
          });
          if (stream.getAudioTracks() && stream.getAudioTracks().length > 0) {
            const newAudioTrack = stream.getAudioTracks()[0];
            this._audioProducer.pause();
            await this._audioProducer.replaceTrack({ track: newAudioTrack });
            this._audioProducer.resume();
          }
        }
  
      });
  
      return {
        id: this._audioProducer.id,
        kind: this._audioProducer.kind
      };
    } catch (error) {
      console.log(error);
    }
		
	}

	async close(reason='') {
		console.debug('stream close: ', this._id, reason);
		await this._sendRequest('stream/close', {streamId: this._id});

    for (const obj of [this._audioProducer]) {
      if (obj) {
        obj.close();
      }
    }
	}
}
